import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import WorkflowTable from "../../components/Admin/workflows"

const Workflow = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Workflows | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <WorkflowTable />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Workflow
